import PropTypes from "prop-types";
import { useState } from "react";

/*
 * Shared lookup card for both return pages. Submitting lifts the trimmed
 * value; the page decides what to do with it.
 */
const LookupPanel = ({
  id,
  title,
  subtitle,
  label,
  placeholder,
  help,
  action,
  loadingAction,
  isLoading,
  initialValue,
  onSubmit,
}) => {
  const [value, setValue] = useState(initialValue || "");

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(value.trim());
  };

  return (
    <section className="c4rtn__lookup" aria-labelledby={`${id}-heading`}>
      <h1 className="c4rtn__lookup-title" id={`${id}-heading`}>
        {title}
      </h1>
      <p className="c4rtn__lookup-sub">{subtitle}</p>

      <form className="c4rtn__form" onSubmit={handleSubmit} noValidate>
        <div className="c4rtn__field">
          <label className="c4rtn__label" htmlFor={`${id}-input`}>
            {label}
          </label>
          <input
            className="c4rtn__input"
            id={`${id}-input`}
            type="text"
            autoComplete="off"
            placeholder={placeholder}
            value={value}
            onChange={(e) => setValue(e.target.value)}
            aria-describedby={`${id}-help`}
            required
          />
        </div>

        <button
          className="c4rtn__btn c4rtn__btn--primary c4rtn__submit"
          type="submit"
          disabled={isLoading || !value.trim()}
        >
          {isLoading ? loadingAction : action}
        </button>
      </form>

      <p className="c4rtn__help" id={`${id}-help`}>
        {help}
      </p>
    </section>
  );
};

LookupPanel.propTypes = {
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  label: PropTypes.string.isRequired,
  placeholder: PropTypes.string,
  help: PropTypes.string,
  action: PropTypes.string.isRequired,
  loadingAction: PropTypes.string,
  isLoading: PropTypes.bool,
  initialValue: PropTypes.string,
  onSubmit: PropTypes.func.isRequired,
};

export default LookupPanel;
